import { SelectPhotoModal } from "./SelectPhotoModal";

export default SelectPhotoModal;
